import store from '../store/store';
import { mutatorAction } from 'satcheljs';

export default mutatorAction('SET_USER_CLIENT_ID', (userClientId: string) => {
    store.bookingData.UserClientId = userClientId;
});
